"use strict";

var LoggerInstance = require("js-logger").get("SavedPaymentHelper");

var SavedPaymentsApi = require("../api/SavedPaymentsApi");

var ActionsHelper = require("../actions/ActionsHelper");

var Spinner = require("../client/Spinner");

var PaymentHelper = require("../commonComponents/PaymentHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var LinkMessageHelper = require("../shared/LinkMessageHelper");

var creditCardsAndEftsSelector = "[data-component='savedPayments.creditCard'], [data-component='savedPayments.eft']";
var isPrimaryCheckboxSelector = "[data-component='savedPayments.isPrimary.input']";
var isPrimaryDataDrivenSelector = "[data-dynamic='savedPayment.IsPrimary']";
var savedPaymentsSelector = "[data-component='savedPayments']";
var addNewSavedPaymentSelector = "[data-component='savedPayments.addNew']";

var billingAddressesAddSmartyStreetsInstanceName = "billingAddressesAdd";

var SavedPaymentHelper = {
	initializeSavedPayments: function (isCheckout) {
		var $creditCardsAndEfts = $("body").find(creditCardsAndEftsSelector);
		var $checkboxElements = $creditCardsAndEfts.find("[data-component='savedPayments.isPrimary.input'], [data-component='savedPayments.isPrimary.label']");
		$checkboxElements.on("click.savedPaymentsHelper", (event) => this._changePrimarySavedPayment(event));
	
		var $newSavedPayment = $("body").find("[data-component='savedPayments.addNew']");
		var $newSavedPaymentPrimaryCheckbox = $newSavedPayment.find("[data-component='savedPayments.isPrimary.input'], [data-component='savedPayments.isPrimary.label']");
		$newSavedPaymentPrimaryCheckbox.on("click.savedPaymentsHelper", (event) => this._handleNewPaymentIsPrimaryChange(event));

		var $newSavedPaymentSavePaymentCheckbox = $newSavedPayment.find("[data-component='paymentType.savePayment.input'], [data-component='paymentType.savePayment.label']");
		$newSavedPaymentSavePaymentCheckbox.on("click.savedPaymentsHelper", (event) => this._handleNewPaymentSavePaymentChange(event));

		if (isCheckout && !$creditCardsAndEfts.length) {
			this._showAddNewPayment($("body").find(savedPaymentsSelector));
		}
	},

	handleAddNewPaymentLinkClick: function (event) {
		var returnedEvent = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("addNewPayment"));
		if (!returnedEvent) {
			return false;
		}

		var $savedPayments = $(event.target).closest(savedPaymentsSelector);
		this._showAddNewPayment($savedPayments);

		return false;
	},

	_showAddNewPayment: function ($savedPaymentComponent) {
		$savedPaymentComponent.find("[data-component='savedPayments.addPrompt']").hide();
		$savedPaymentComponent.find("[data-component='savedPayments.addNew']").show();
		$savedPaymentComponent.find("[data-component='savedPayments.accountSavedPaymentSubmitButton']").show();

		var $savedPaymentCheckoutSelector = $("[data-component='savedPayments.addNew'] [data-component='savedPayments.selector']");
		if ($savedPaymentCheckoutSelector.length) {
			$savedPaymentCheckoutSelector.click()
		}
	},

	deleteSavedPayment: function (paymentRecordId) {
		//Cannot do normal process for Ctrl+click because no event is passed in
		//	Using window.event because this works in Chrome and we are saying the designer only works in Chrome.
		if (this._isDesignMode()) {
			this._getEventOrReturn(window.event, LinkMessageHelper.linkMessageMapper("removeSavedPayment"));
			return;
		}

		Spinner.showSpinner();

		SavedPaymentsApi.deleteSavedPayment(paymentRecordId)
			.done(() => window.location.reload())
			.fail(jqHXR => {
				if (((jqHXR || {}).responseJSON || {}).message == "Cannot delete Saved Payment because it is used on a recurring.") {
					BootstrapPrompt.alert(this._getWizardValue(WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES, WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.CANNOT_DELETE_BECAUSE_OF_RECURRING));
				} else if (((jqHXR || {}).responseJSON || {}).message == "Cannot delete Saved Payment because it is used on an auto-renewing subscription.") {
					BootstrapPrompt.alert(this._getWizardValue(WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES, WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.CANNOT_DELETE_BECAUSE_OF_AUTO_RENEWING_SUBSCRIPTION));
				} else {
					BootstrapPrompt.alert(jqHXR);
				}
				Spinner.removeSpinner();
			});

		return false;
	},

	_changePrimarySavedPayment: function (event) {
		var $savedPayment = $(event.currentTarget).closest(creditCardsAndEftsSelector);
		var $checkbox = $savedPayment.find(isPrimaryCheckboxSelector);
		
		// If the label was clicked, we need to check the box.  If the checkbox was clicked, it is already accurate.
		if (event.currentTarget.localName === "label") {
			var isChecked = $checkbox.prop("checked");
			$checkbox.prop("checked", !isChecked);
		}

		this._confirmAndUpdateSavedPayment($savedPayment, /*shouldMakePrimary*/$checkbox.prop("checked"));
	},

	_handleNewPaymentIsPrimaryChange: function (event) {
		var $newSavedPayment = $(event.currentTarget).closest(addNewSavedPaymentSelector);
		var $isPrimaryCheckbox = $newSavedPayment.find(isPrimaryCheckboxSelector);
		var isChecked = $isPrimaryCheckbox.prop("checked");
		
		// If the label was clicked, the box has not been checked yet.  If the checkbox was clicked, it is already accurate.
		if (event.currentTarget.localName === "label") {
			isChecked = !isChecked;
		}

		if (isChecked) {
			var $savePaymentCheckbox = $newSavedPayment.find("[data-component='paymentType.savePayment.input']");
			$savePaymentCheckbox.prop("checked", true);
		}
	},

	_handleNewPaymentSavePaymentChange: function (event) {
		var $newSavedPayment = $(event.currentTarget).closest(addNewSavedPaymentSelector);
		var $savePaymentCheckbox = $newSavedPayment.find("[data-component='paymentType.savePayment.input']");
		var isChecked = $savePaymentCheckbox.prop("checked");

		// If the label was clicked, the box has not been checked yet.  If the checkbox was clicked, it is already accurate.
		if (event.currentTarget.localName === "label") {
			var isChecked = !isChecked;
		}

		if (!isChecked) {
			var $isPrimaryCheckbox = $newSavedPayment.find(isPrimaryCheckboxSelector);
			$isPrimaryCheckbox.prop("checked", false);
		}
	},

	_confirmAndUpdateSavedPayment: function ($savedPayment, shouldMakePrimary) {
		if (shouldMakePrimary) {
			BootstrapPrompt.confirm({
				message: this._getWizardValue(
					WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
					WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.MAKE_PRIMARY_CONFIRMATION_MESSAGE
				),
				btnOKLabel: this._getWizardValue(
					WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
					WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.MAKE_PRIMARY_CONFIRMATION_CONFIRM_BUTTON_TEXT
				),
				btnCancelLabel: this._getWizardValue(
					WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
					WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.MAKE_PRIMARY_CONFIRMATION_CANCEL_BUTTON_TEXT
				)
			}, (result) => {
				this._updateOrResetSavedPayment(result, $savedPayment, shouldMakePrimary);
			});
		} else {
			BootstrapPrompt.confirm({
				message: this._getWizardValue(
					WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
					WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.REMOVE_DEFAULT_CONFIRMATION_MESSAGE
				),
				btnOKLabel: this._getWizardValue(
					WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
					WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.REMOVE_DEFAULT_CONFIRMATION_CONFIRM_BUTTON_TEXT
				),
				btnCancelLabel: this._getWizardValue(
					WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
					WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.REMOVE_DEFAULT_CONFIRMATION_CANCEL_BUTTON_TEXT
				)
			}, (result) => {
				this._updateOrResetSavedPayment(result, $savedPayment, shouldMakePrimary);
			});
		}
	},

	_updateOrResetSavedPayment: function(shouldUpdate, $savedPayment, shouldMakePrimary) {
		if (shouldUpdate) {
			this._updateSavedPayment($savedPayment, shouldMakePrimary);
		} else {
			this._updateSavedPaymentsDisplay($savedPayment, shouldMakePrimary, /*updateWasSuccessful*/false);
		}
	},

	_updateSavedPayment: function ($savedPayment, shouldMakePrimary) {
		if (this._isDesignMode()) {
			return;
		}

		var $savedPaymentsComponent = $savedPayment.closest(savedPaymentsSelector);

		Spinner.showSpinner($savedPaymentsComponent);
		SavedPaymentsApi.updateSavedPayment($savedPayment.attr("data-saved-payment-id"), shouldMakePrimary)
			.done(() => {
				this._updateSavedPaymentsDisplay($savedPayment, shouldMakePrimary, /*updateWasSuccessful*/true);
				Spinner.removeSpinner($savedPaymentsComponent);
			}).fail(() => {
				this._updateSavedPaymentsDisplay($savedPayment, shouldMakePrimary, /*updateWasSuccessful*/false);
				if (shouldMakePrimary) {
					BootstrapPrompt.alert(this._getWizardValue(
						WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
						WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.MAKE_PRIMARY_ERROR_TEXT
					));
				} else {
					BootstrapPrompt.alert(this._getWizardValue(
						WizardConstants.WIZARDS.SAVED_PAYMENT_DISPLAY_MESSAGES,
						WizardConstants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS.REMOVE_DEFAULT_ERROR_TEXT
					));
				}

				Spinner.removeSpinner($savedPaymentsComponent);
			});

		return false;
	},

	_updateSavedPaymentsDisplay: function ($savedPayment, shouldMakePrimary, updateWasSuccessful) {
		var $checkbox = $savedPayment.find(isPrimaryCheckboxSelector)

		if (!updateWasSuccessful) {
			$checkbox.prop("checked", !shouldMakePrimary);
			return;
		}
		
		var $savedPaymentsComponent = $savedPayment.closest(savedPaymentsSelector);
		var $allCheckboxes = $savedPaymentsComponent.find(creditCardsAndEftsSelector).find(isPrimaryCheckboxSelector);
		var $allIsPrimaryDataDrivenLabels = $savedPaymentsComponent.find(isPrimaryDataDrivenSelector);
		
		$allCheckboxes.prop("checked", false);
		$allIsPrimaryDataDrivenLabels.text("No");
		
		if (shouldMakePrimary) {
			$checkbox.prop("checked", true);
			var $isPrimaryDataDrivenLabel = $savedPayment.find(isPrimaryDataDrivenSelector);
			$isPrimaryDataDrivenLabel.text("Yes");
		}
	},

	addSavedPaymentToAccount: function (event) {
		try {
			event = this._getEventOrReturn(event, "Saved Payment Added.");
			if (!event) {
				return;
			}

			var $savedPaymentComponent = $(event.target).closest(savedPaymentsSelector);
			var $savedPaymentAddNewComponent = $savedPaymentComponent.find("[data-component='savedPayments.addNew']");
			var components = [
				$savedPaymentAddNewComponent
			];

			Spinner.showSpinner();
			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				PaymentHelper.getPaymentData(
					window.AccountStore.get("wizardCompanyErrorMessages"),
					window.AccountStore.get("wizardCompanyEftErrorMessages"),
					(hostedPageTokenObject) => {
						var isPrimary = $savedPaymentAddNewComponent.find(isPrimaryCheckboxSelector).prop("checked");

						var addSavedPayment = function () {
							SavedPaymentsApi.addSavedPaymentToAccount({
								companyCode: window.AccountStore.get("companyCode"),
								isPrimary,
								payment: hostedPageTokenObject
							}).done(() => {
								window.location.reload();
							}).fail((jqXHR) => {
								PaymentHelper.clearPaymentData($savedPaymentComponent);
								var savedPaymentErrorMessage = window.AccountStore.getWizardValue(
									WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
									WizardConstants.ACCOUNT_MESSAGE_FIELDS.SAVED_PAYMENT_ERROR);
								ApiHelper.displayErrorMessage(jqXHR, savedPaymentErrorMessage, /*isSafeToDisplayRequired*/ true);
								Spinner.removeSpinner();
							});
						}

						if (hostedPageTokenObject.billingAddressInformation.selectionType === "NEW") {
							SmartyStreets.verifyAddress(billingAddressesAddSmartyStreetsInstanceName)
								.done(() => {
									addSavedPayment();
								})
								.fail(() => Spinner.removeSpinner());
						} else {
							addSavedPayment();
						}
					},
					() => Spinner.removeSpinner(), $savedPaymentComponent);
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, this._isDesignMode(), isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	},

	_getWizardValue: function(wizardName, wizardField) {
		var wizardValue = "";
		if (window.CheckoutActions) {
			wizardValue = window.CheckoutActions.getWizardValue(wizardName, wizardField);
		}

		if (!wizardValue && window.AccountStore) {
			wizardValue = window.AccountStore.getWizardValue(wizardName, wizardField);
		}

		return wizardValue;
	},

	_isDesignMode: function() {
		return (window.CheckoutActions && window.CheckoutActions.isDesignMode()) || (window.AccountStore && window.AccountStore.get("isDesignMode"));
	}
};

module.exports = SavedPaymentHelper;